(() => {
  class InstrumentPlayer {
    constructor(container) {
      if (!container) return;

      this.container = container;
      this.audios = {};
      this.active = null;

      this.init();
    }

    init() {
      if (!this.container) return;

      const audioEls = this.container.querySelectorAll('audio');
      if (!audioEls.length) return;

      audioEls.forEach(audio => {
        const key = audio.dataset.audio;
        if (!key) return;

        this.audios[key] = audio;

        audio.addEventListener('timeupdate', () => {
          this.updateProgress(key);
        });

        audio.addEventListener('ended', () => {
          this.setPlaying(key, false);
        });
      });

      this.buildWaveforms();
      this.bindControls();
    }

    buildWaveforms() {
      const waveforms = this.container.querySelectorAll('.instrument-waveform');
      if (!waveforms.length) return;

      waveforms.forEach(waveform => {
        if (waveform.querySelector('.waveform-bars')) return;

        const bars = document.createElement('div');
        bars.className = 'waveform-bars';

        for (let i = 0; i < 24; i++) {
          bars.appendChild(document.createElement('span'));
        }

        const progress = document.createElement('div');
        progress.className = 'waveform-progress';

        waveform.appendChild(bars);
        waveform.appendChild(progress);

        waveform.addEventListener('click', e => {
          const name = waveform.dataset.progress;
          const audio = this.audios[name];
          if (!audio || !audio.duration) return;

          const rect = waveform.getBoundingClientRect();
          const percent = (e.clientX - rect.left) / rect.width;
          audio.currentTime = percent * audio.duration;
        });
      });
    }

    bindControls() {
      this.container.addEventListener('click', e => {
        const btn = e.target.closest('button');
        if (!btn || !this.container.contains(btn)) return;

        const name = btn.dataset.audio;
        const action = btn.dataset.action;
        const audio = this.audios[name];

        if (!audio) return;

        if (action === 'toggle') {
          audio.paused ? this.play(name) : this.pause(name);
        }

        if (action === 'restart') {
          audio.currentTime = 0;
          this.play(name);
        }
      });
    }

    play(name) {
      if (this.active && this.active !== name) {
        this.pause(this.active);
      }

      const audio = this.audios[name];
      if (!audio) return;

      audio.play();
      this.active = name;
      this.setPlaying(name, true);
    }

    pause(name) {
      const audio = this.audios[name];
      if (!audio) return;

      audio.pause();
      this.setPlaying(name, false);

      if (this.active === name) {
        this.active = null;
      }
    }

    setPlaying(name, playing) {
      const row = this.container.querySelector(`[data-instrument="${name}"]`);
      if (!row) return;

      const btn = row.querySelector('.instrument-button');
      if (!btn) return;

      row.classList.toggle('is-playing', playing);
      btn.textContent = playing ? '❚❚' : '▶';
    }

    updateProgress(name) {
      const audio = this.audios[name];
      if (!audio || !audio.duration) return;

      const percent = (audio.currentTime / audio.duration) * 100;
      const progress = this.container.querySelector(
        `.instrument-waveform[data-progress="${name}"] .waveform-progress`
      );

      if (progress) {
        progress.style.width = `${percent}%`;
      }
    }
  }

  function initInstrumentPlayers(root = document) {
    root.querySelectorAll('#instrumentPlayer').forEach(container => {
      if (container.__instrumentPlayerInitialized) return;
      container.__instrumentPlayerInitialized = true;
      new InstrumentPlayer(container);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initInstrumentPlayers();
  });

  // Shopify section re-render support
  document.addEventListener('shopify:section:load', e => {
    initInstrumentPlayers(e.target);
  });
})();
